import { useEffect } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { useStore } from '@/stores';
import { LOCAL_STORAGE } from '@/shared/constants/localStorage';

type useInitDynamicsScriptsProps = {
  setDynVersion: (version: 1 | 2) => void;
  currentTabId: string;
};

export const useInitDynamicsScripts = ({
  setDynVersion,
  currentTabId,
}: useInitDynamicsScriptsProps) => {
  const {
    settingsStore: {
      setInitializationState,
      initializationState,
      setCurrentTabId,
      setActiveTabId,
    },
  } = useStore();

  const injectDynamicsScript = async () => {
    const activeTabId = localStorage.getItem(LOCAL_STORAGE.LS_TAB_ID_KEY);

    // If there is no active tab id - make this tab active and put that id in local storage
    if (!activeTabId) {
      localStorage.setItem(LOCAL_STORAGE.LS_TAB_ID_KEY, currentTabId);
      setActiveTabId(currentTabId);
    } else {
      setActiveTabId(activeTabId);
    }
    setCurrentTabId(currentTabId);

    setInitializationState(() => {
      return {
        percent: initializationState.percent + 10,
        prompt: {
          ...initializationState.prompt,
          dynScript: {
            text: 'Injecting Dynamics Channel Integration script...',
            color: 'secondary',
          },
        },
      };
    });

    Dynamics.createScript();
    await Dynamics.getEnvironmentFromApi();
    const version = Dynamics.getVersion();

    setDynVersion(version);
    setInitializationState(() => {
      return {
        percent: initializationState.percent + 20,
        prompt: {
          ...initializationState.prompt,
          dynScript: {
            text: 'Dynamics Channel Integration script injected',
            color: 'success',
          },
        },
      };
    });
  };

  useEffect(() => {
    injectDynamicsScript();
  }, []);
};
